import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function openEvent(uuid: string): Promise<AxiosResponse<void>> {
  return instance.post(`/event/${uuid}/open`)
}
